import { createSlice } from '@reduxjs/toolkit';
import { EventSearchFiltersState } from '../../utils/types';

const initialState: EventSearchFiltersState = {
    countryCode: 'GB',
    city: '',
    eventType: null,
    startDate: null,
};

export const eventSearchFiltersSlice = createSlice({
    name: 'necessaryData',
    initialState,
    reducers: {
        setCity(state, action) {
            state.city = action.payload;
        },
        setCountryCode(state, action) {
            state.countryCode = action.payload;
        },
        setEventType(state, action) {
            state.eventType = action.payload;
        },
        setStartDate(state, action) {
            state.startDate = action.payload;
        },
    },
});

const { actions, reducer } = eventSearchFiltersSlice;

export const { setCountryCode, setCity, setEventType, setStartDate } = actions;

export default reducer;
